<template>
    <div class="screen pt20 pl30 col666">
        <div class="flex">
            <a href="javascript:;" class="searchbtn w80 text-center bg-green white mr30 f14" v-if="accountutil.isSuper()" @click="pushMacAddress = true">新增屏幕</a>
            <a href="javascript:;" class="searchbtn w80 text-center bg-green white f14" v-if="accountutil.isSuper()" @click="upMore = true">批量导入屏幕</a>
        </div>
        <div class="topBox flex f-between mb15 mt15 pr30">
            <ul class="flex f-align-center h40">
                <li class="list text-center cur-p" :class="{active:index == navindex}" v-for="(item,index) in navlist" @click="currentPage(index)">{{item.title}}</li>
            </ul>
            <div class="flex f-align-center" v-if="showtablepage == 1">
                <p class="f14 mr10">经销商名称</p>
                <div class="inputbox">
                    <el-input v-model="agentName" placeholder="经销商名称"></el-input>
                </div>
                <a href="javascript:;" @click="searchAgent" class="searchbtn w100 text-center bg-green white ml15 f14">搜索</a>

                <p class="f14 mr10 ml20">集团名称</p>
                <div class="inputbox">
                    <el-input v-model="groupName" placeholder="集团名称"></el-input>
                </div>
                <a href="javascript:;" @click="searchGroup" class="searchbtn w100 text-center bg-green white ml15 f14">搜索</a>
            </div>
            <div class="flex f-align-center" v-if="showtablepage == 4">
                <p class="f14 mr10 ml20">Mac地址</p>
                <div class="inputbox">
                    <el-input v-model="searchMac" placeholder="Mac地址搜索"></el-input>
                </div>
                <a href="javascript:;" @click="superlist(1)" class="searchbtn w100 text-center bg-green white ml15 f14">搜索</a>
            </div>
        </div>
        <div class="mb15 mt15 mr30" v-show="showtablepage == 4">
            <template>
                <el-table :data="allscode" border slot="empty">
                    <el-table-column prop="MacAddress" label="Mac地址">
                    </el-table-column>
                    <el-table-column prop="online" label="在线状态">
                    </el-table-column>
                    <el-table-column prop="version" label="版本号">
                    </el-table-column>
                    <el-table-column prop="MacAddress" label="Mac地址">
                    </el-table-column>
                    <el-table-column prop="time" label="添加时间">
                    </el-table-column>
                    <el-table-column prop="isOut" label="是否转出">
                    </el-table-column>
                    <el-table-column prop="name" label="当前所有者">
                    </el-table-column>
                    <el-table-column prop="action" label="操作">
                        <template slot-scope="scope">
                            <p class="cur-p green" v-if="CanResetBinding(scope.row)== true" @click="showTip(scope.row)"> 解绑屏幕</p>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <div class="mb15 mt15 mr30" v-show="showtablepage == 0">
            <p class="mb15">当前库存屏幕：<span class="red">{{page.totalcount?page.totalcount:0}}个</span></p>
            <template>
                <el-table :data="tableData" border slot="empty">
                    <el-table-column prop="MacAddress" label="Mac地址">
                    </el-table-column>
                    <el-table-column prop="time" label="添加时间">
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <div class="mb15 mt15 mr30" v-show="showtablepage == 1">
            <p class="mb15">已分配屏幕：<span class="red">{{totalScreen}}个</span></p>
            <template>
                <el-table :data="givemsg" border slot="empty">
                    <el-table-column prop="name" label="接收屏幕的客户">
                    </el-table-column>
                    <el-table-column prop="givenum" label="转出屏幕数量">
                    </el-table-column>
                    <el-table-column prop="usednum" label="已使用屏幕数量">
                    </el-table-column>
                    <el-table-column prop="time" label="转出屏幕时间">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注">
                    </el-table-column>
                    <el-table-column label="操作"> 
                        <template slot-scope="scope">
                            <p class="cur-p green" @click="screenDetail(scope.row,1)">查看屏幕</p>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <div class="mb15 mt15 mr30" v-show="showtablepage == 2">
            <p class="mb15">接收屏幕总数量：<span class="red">{{totalScreen}}个</span></p>
            <template>
                <el-table :data="receivemsg" border slot="empty">
                    <el-table-column prop="num" label="接收屏幕数量">
                    </el-table-column>
                    <el-table-column prop="agent" label="转出屏幕商家">
                    </el-table-column>
                    <el-table-column prop="time" label="接收屏幕时间">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注">
                    </el-table-column>
                    <el-table-column label="操作"> 
                        <template slot-scope="scope">
                            <p class="cur-p green" @click="screenDetail(scope.row,2)">查看屏幕</p>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <div class="mb15 mt15 mr30" v-show="showtablepage == 3">
            <p class="mb15">接收屏幕总数量：<span class="red">{{totalScreen}}个</span></p>
            <template>
                <el-table :data="addmsg" border slot="empty">
                    <el-table-column prop="num" label="添加屏幕数量">
                    </el-table-column>
                    <el-table-column prop="time" label="添加屏幕时间">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注">
                    </el-table-column>
                    <el-table-column label="操作"> 
                        <template slot-scope="scope">
                            <p class="cur-p green" @click="screenDetail(scope.row,3)">查看屏幕</p>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <div v-if="page.totalcount > 10">
            <template>
                <div class="block pt20 text-right">
                    <el-pagination @current-change="changepages" :current-page="page.pageno" :page-size="page.pagesize" layout="total, prev, pager, next, jumper"
                        :total="page.totalcount">
                    </el-pagination>
                </div>
            </template>
        </div>
        <el-dialog title="导入屏幕" :visible.sync="pushMacAddress" width="400px" :closeOnClickModal="false" @close="clearData">
            <div>
                <el-form label-width="100px">
                    <el-form-item label="Mac地址:" required>
                        <el-input v-model="macAddress" placeholder="请输入Mac地址"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="macRemark" placeholder="输入备注信息"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="text-center">
                <a href="javascript:;" class="searchbtn w80 text-center bg-green white f14" @click="addscreen">确 定</a>
            </div>
        </el-dialog>
        <el-dialog title="批量导入屏幕" :visible.sync="upMore" width="30%" center :closeOnClickModal="false" @close="clearfile">
            <div>
                <el-form label-width="90px">
                    <el-form-item label="批量导入：">
                        <el-upload
                            class="filebox"
                            :action="qiniuUrl"
                            :on-success="success"
                            :on-remove="handleRemove"
                            :before-upload ="beforeImg"
                            :data="uploadImg"
                            :file-list="fileList">
                            <a href="javascript:;" class="searchbtns">点击上传</a>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input type="textarea" v-model="macMoreRemark" placeholder="输入备注信息"></el-input>
                    </el-form-item>
                </el-form>
                <a class="pl20 f12 mb5" style="color:#18C3B1" href="http://xpic.biezao.com/propsmodel.xlsx">下载Excel模板</a>
                <div class="text-center">
                    <a href="javascript:;" class="searchbtns" @click="addmorescreen">导入</a>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="查看分配屏幕" :visible.sync="giveDetail" width="850px" :closeOnClickModal="false">
            <div class="flex f-between f-align-center"> 
                <div class="flex">
                    <p>给<span class="red"> “{{currentData.name}}” </span>分配的屏幕：<span class="red">{{currentData.givenum}}个</span></p>
                    <p class="ml10">分配时间：{{currentData.time}}</p>
                </div>
                <div class="flex f-align-center">
                </div>
            </div>
            <div class="mb15 mt15">
                <template>
                    <el-table :data="screenData" border slot="empty">
                        <el-table-column prop="mac" label="Mac地址">
                        </el-table-column>
                        <el-table-column prop="status" label="使用状态">
                        </el-table-column>
                        <el-table-column prop="agent" label="接收屏幕经销商">
                        </el-table-column>
                        <el-table-column prop="group" label="接收屏幕集团">
                        </el-table-column>
                        <el-table-column prop="store" label="使用门店">
                        </el-table-column>
                        <el-table-column prop="address" label="屏幕投放位置">
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <div v-if="screenDataPage.totalcount > 10">
                <template>
                    <div class="block pt20 text-right">
                        <el-pagination @current-change="propsorderdetaillist" :current-page="screenDataPage.pageno" :page-size="screenDataPage.pagesize" layout="total, prev, pager, next, jumper"
                            :total="screenDataPage.totalcount">
                        </el-pagination>
                    </div>
                </template>
            </div>
        </el-dialog>
        <el-dialog title="查看屏幕" :visible.sync="ownerDetail" width="850px" :closeOnClickModal="false">
                <div class="flex f-between f-align-center"> 
                    <div class="flex">
                       <p>接收屏幕数量：<span class="red">{{currentData.num}}个</span> 接收时间：<span class="red"></span>{{currentData.time}}</p>
                    </div>
                    <div class="flex f-align-center">
                      
                    </div>
                </div>
                <div class="mb15 mt15">
                    <template>
                        <el-table :data="screenData" border slot="empty">
                            <el-table-column prop="mac" label="Mac地址">
                            </el-table-column>
                            <el-table-column prop="sort" sortable label="转出屏幕状态">
                            </el-table-column>
                            <el-table-column prop="status" label="使用状态">
                            </el-table-column>
                            <el-table-column prop="agent" label="接收屏幕经销商">
                            </el-table-column>
                            <el-table-column prop="group" label="接收屏幕集团">
                            </el-table-column>
                            <el-table-column prop="store" label="使用门店">
                            </el-table-column>
                            <el-table-column prop="address" label="屏幕投放位置">
                            </el-table-column>
                        </el-table>
                    </template>
                </div>
                <div v-if="screenDataPage.totalcount > 10">
                    <template>
                        <div class="block pt20 text-right">
                            <el-pagination @current-change="propsorderdetaillist" :current-page="screenDataPage.pageno" :page-size="screenDataPage.pagesize" layout="total, prev, pager, next, jumper"
                                :total="screenDataPage.totalcount">
                            </el-pagination>
                        </div>
                    </template>
                </div>
            </el-dialog>
            <el-dialog title="温馨提示" :visible.sync="showretbind" width="400" center :closeOnClickModal="false">
            <p>确定解绑{{sncodename}}屏幕吗</p>
            <div class="text-center mt20">
                <a href="javascript:;" class="searchbtns" @click="ResetBinding">确 定</a>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                totalScreen:0,
                showtablepage:0,
                searchMac:'',
                macAddress:'',
                macRemark:'',
                pushMacAddress:false,
                upMore:false,
                macMoreRemark:'',
                navlist:[
                    {
                        title:'当前库存屏幕',
                        type:0
                    },{
                        title:'转出配屏幕记录',
                        type:1
                    },{
                        title:'接收屏幕记录',
                        type:2
                    }
                ],
                navindex:0,
                agentName:'',
                groupName: '',
                allscode:[],
                tableData:[],
                givemsg:[],
                page:{
                    pageno:1,
                    pagesize:10,
                    totalcount:24
                },
                radio:'1',
                remark:'',
                qiniuUrl:'',
				domain: '', //图片外链域名
				uploadImg: {
					token: ''
                },
                fileList:[],
                pids:[],
                detailAddress:'',
                currentData:{},
                giveDetail:false,
                searchtype:0,
                screenData:[],
                screenDataPage:{},
                receivemsg:[],
                addmsg:[],
                ownerDetail:false,
                showretbind:false,
                ownerData:[],
                ownerDataPage:{},
                listtype:1,
                propid:0,
                sncodename:'',
            }
        },
        created(){
            var that = this;
            if(that.accountutil.isSuper()){
                let json = {
                    title:'添加屏幕记录',
                    type:3
                }
                let all = {
                    title:'全部屏幕',
                    type:4
                }
                that.navlist.unshift(all)
                that.navlist.push(json)
            }
            that.showtablepage = that.navlist[that.navindex].type
            that.qiniuUrl = that.api.qiniuUrl;
            that.uploadImgQiniu();
            if(that.showtablepage == 0){
                that.listsbyowner(1); 
            }else{
                that.superlist(1)
            }
        },
        methods:{
            currentPage(val){
                var that = this;
                that.navindex = val;
                var type = that.navlist[val].type
                that.showtablepage = that.navlist[val].type
                console.log(type)
                if(type == 0){
                    that.listsbyowner(1);
                }else if(type == 1){
                    that.searchtype = 2
                    that.propsorderlist(1)
                }else if(type == 2){
                    that.searchtype = 1
                    that.propsorderlist(1)
                }else if(type == 3){
                    that.searchtype = 3
                    that.propsorderlist(1)
                }else if(type == 4){
                    that.superlist(1)
                }
            },
            changepages(val){
                let that = this;
                if(that.showtablepage == 0){
                    that.listsbyowner(val);
                }else if(that.showtablepage == 4){
                    that.superlist(val)
                }else{
                    that.propsorderlist(val)
                }
            },
            clearData(){
                var that = this;
                that.pushMacAddress = false;
                that.radio = '1';
                that.remark = '';
                that.macAddress = '';
                that.macRemark = '';
            },
            screenDetail(val,type){
                let that = this;
                that.currentData = val;
                if(type == 1){
                    that.propsorderdetaillist(1)
                    that.giveDetail = true;
                }else{
                    that.listtype = type == 3?3:1;
                    that.ownerDetail = true;
                    that.propsorderdetaillist(1)
                }
                
            },
            //上传图片
			 uploadImgQiniu() {
				var that = this;
				var uploader;
				var req = {}
				req = JSON.stringify(req);
				$.ajax({
					type: 'post',
					url: that.api.getuptoken,
					data: {
						req: req
					},
					success: function (res) {
						if (res.result.success) {
						that.uploadImg.token = res.token;
						that.domain = res.domain;
						}
					}
                })
			},
			//图片上传限制
			beforeImg(file) {
                var that = this;
				var isLt5M = file.size / 1024 / 1024 < 5;
				var name = file.name;
                var suffix = name.substring((name.lastIndexOf('.')+1),name.length)
                //application/vnd.ms-excel
				if (suffix != 'xlsx' && suffix != 'xls') {
					this.$message.error('抱歉！上传文件格式有误，请下载模板格式进行参考上传！');
					return false;
				}
				// if (!isLt5M) {
				// 	this.$message.error('上传文件大小不能超过 5MB!');
				// 	return false;
				// }
			},
			handleRemove(file, fileList) {
				var that = this;
				that.fileList = [];
                $(".filebox .el-upload--text").show();
			},
			success(file, fileList) {
				var that = this;
				var domain = that.domain; //7牛云外链
				var hash = fileList.response.hash; //7牛云返回的图片路径
				var url = domain + hash; //组合成真正的图片地址
				that.fileList.push({ name:fileList.name,url: url,key:hash });
				$(".filebox .el-upload--text").hide();
            },
            listsbyagentid(page){
                var that = this;
                var req = {
                    agentid:that.accountutil.getAgent().agentid,
                    typeid:1000,
                    status:0,
                    usestatus:0,
                    page:{
                        pageno:page,
                        pagesize:10
                    }
                }
                that.tableData = [];
                that.httputil.post({
                    that: that,
                    url: that.api.listsbyagentid,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsinfo){
                            for(var i=0;i<res.propsinfo.length;i++){
                                var target = res.propsinfo[i];
                                var json = {
                                    pid:target.pid,
                                    MacAddress:target.sncode,
                                    time:new Date(target.createtime*1000).format("yyyy/MM/dd HH:mm:ss"),
                                }
                                that.tableData.push(json)
                            }
                        }
                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            listsbyowner(page) {
                var that = this;
                var req = {
                    typeid: 1000,
                    page: {
                        pageno: page,
                        pagesize: 10
                    }
                }
                if(that.accountutil.isGroup()){
                    req.owner = that.accountutil.getBid();
                    req.ownertype = 300;
                }else{
                    req.owner = that.accountutil.getAgent().agentid;
                    req.ownertype = 200;
                }
                that.tableData = [];
                that.httputil.post({
                    that: that,
                    url: that.api.listsbyowner,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsinfo) {
                            for(var i=0;i<res.propsinfo.length;i++){
                                var target = res.propsinfo[i];
                                var json = {
                                    pid:target.pid,
                                    MacAddress:target.sncode,
                                    time:new Date(target.createtime*1000).format("yyyy/MM/dd HH:mm:ss"),
                                }
                                that.tableData.push(json)
                            }
                        }
                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            addscreen(){
                var that = this;
                var req = {
                    agentid:that.accountutil.getAgent().agentid,
                    propsinfo:{
                        type:1000,
                        sncode:that.macAddress,
                        remark:that.macRemark,
                    }
                }
                that.httputil.post({
                    that: that,
                    url: that.api.addscreen,
                    req: req,
                    xmsuccess: function (res) {
                        that.$message({
                            message: '添加成功！',
                            type: 'success'
                        });
                        that.navindex = 0;
                        if(that.accountutil.isSuper()){
                            that.superlist(1);
                        }else{
                            that.listsbyowner(1);
                        }
                        that.pushMacAddress = false;
                        that.macAddress = '';
                        that.macRemark = '';
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            addmorescreen(){
                var that = this;
                if(that.fileList.length == 0){
                    that.$message.error('抱歉！上传文件格式有误，请下载模板格式进行参考上传！');
                    return;
                }
                var req = {
                    agentid:that.accountutil.getAgent().agentid,
                    typeid:1000,
                    filepath:that.fileList[0].url,
                    key:that.fileList[0].key
                }
                that.httputil.post({
                    that: that,
                    url: that.api.addmorescreen,
                    req: req,
                    xmsuccess: function (res) {
                        that.$message({
                            message: '添加成功！',
                            type: 'success'
                        });
                        that.upMore = false;
                        $(".filebox .el-upload--text").show();
                        that.navindex = 0;
                        if(that.accountutil.isSuper()){
                            that.superlist(1);
                        }else{
                            that.listsbyowner(1);
                        }
                        that.fileList = [];
                        that.pushMacAddress = false;
                        that.macAddress = '';
                        that.macRemark = '';
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            searchAgent() {
                var that = this;
                var req = {
                    searchtype: 2,
                    type: 1000,
                    agentname: that.agentName,
                    page: {
                        pageno: 1,
                        pagesize: 9999
                    }
                };

                if(that.accountutil.isGroup()){
                    req.businessid = that.accountutil.getBid();
                    req.businesstype = 300;
                }else{
                    req.businessid = that.accountutil.getAgent().agentid;
                    req.businesstype = 200
                }

                that.givemsg = [];

                that.httputil.post({
                    that: that,
                    url: that.api.propsorderlist,
                    req: req,
                    xmsuccess: function (res) {
                        for(let val of (res.propsorder || [])) {
                            let param = {
                                poid: val.poid,
                                success(num) {
                                    let json = {
                                        poid:val.poid,
                                        id:val.toagent.agentid,
                                        type:val.totype,
                                        name:val.toagent.name,
                                        usednum:num,
                                        givenum:val.num,
                                        time:new Date(val.createtime * 1000).format("yyyy/MM/dd HH:mm:ss"),
                                        remark:val.remark
                                    };
                                    that.givemsg.push(json)
                                }
                            };
                            that.getusedcountbypoid(param);
                        }

                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            searchGroup() {
                var that = this;

                var req = {
                    searchtype: 2,
                    type: 1000,
                    brandname: that.groupName,
                    page: {
                        pageno: 1,
                        pagesize: 9999
                    }
                };

                if(that.accountutil.isGroup()){
                    req.businessid = that.accountutil.getBid();
                    req.businesstype = 300;
                }else{
                    req.businessid = that.accountutil.getAgent().agentid;
                    req.businesstype = 200
                }

                that.givemsg = [];

                that.httputil.post({
                    that: that,
                    url: that.api.propsorderlist,
                    req: req,
                    xmsuccess: function (res) {
                        for(let val of (res.propsorder || [])) {
                            let param = {
                                poid: val.poid,
                                success(num) {
                                    let json = {
                                        poid:val.poid,
                                        id:val.tobrand.bid,
                                        type:val.totype,
                                        name:val.tobrand.name,
                                        usednum:num,
                                        givenum:val.num,
                                        time:new Date(val.createtime * 1000).format("yyyy/MM/dd HH:mm:ss"),
                                        remark:val.remark
                                    };
                                    that.givemsg.push(json)
                                }
                            };
                            that.getusedcountbypoid(param);
                        }

                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            propsorderlist(page){
                var that = this;
                var businessid = 0;
                var businesstype = 0;
                if(that.accountutil.isGroup()){
                    businessid = that.accountutil.getBid()
                    businesstype = 300;
                }else{
                    businessid = that.accountutil.getAgent().agentid;
                    businesstype = 200
                }
                var req = {
                    searchtype:that.searchtype,
                    type:1000,
                    businesstype:businesstype, // 权限控制
                    businessid:businessid, //集团、经销商id
                    page:{
                        pageno:page,
                        pagesize:10
                    }
                }
                that.givemsg = [];
                that.addmsg = [];
                that.receivemsg = [];
                that.httputil.post({
                    that: that,
                    url: that.api.propsorderlist,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsorder){
                            for(let val of res.propsorder){
                                if(that.searchtype == 1){
                                    let name = '';
                                    if(val.fromagent){
                                        name = val.fromagent.name
                                    }else{
                                        name = val.fromstore.name
                                    }
                                    let json = {
                                        id:val.toagent?val.toagent.agentid:val.tobrand.bid,
                                        poid:val.poid,
                                        type:val.totype,
                                        num:val.num,
                                        agent:name,
                                        time:new Date(val.createtime * 1000).format("yyyy/MM/dd HH:mm:ss"),
                                        remark:val.remark
                                    }
                                    that.receivemsg.push(json)
                                }
                                if(that.searchtype == 2){
                                    let name,id,usednum;
                                    if(val.totype == 300 ){
                                        name = val.tobrand.name;
                                        id = val.tobrand.bid;
                                    }
                                    if(val.totype == 200 ){
                                        name = val.toagent.name;
                                        id = val.toagent.agentid;
                                    }
                                    if(val.totype == 400){
                                        name = val.tostore.name;
                                        id = val.tostore.soid;
                                    }
                                    let param = {
                                        poid: val.poid, 
                                        success(num) {
                                            let json = {
                                                poid:val.poid,
                                                id:id,
                                                type:val.totype,
                                                name:name,
                                                usednum:num,
                                                givenum:val.num,
                                                time:new Date(val.createtime * 1000).format("yyyy/MM/dd HH:mm:ss"),
                                                remark:val.remark
                                            }
                                            that.givemsg.push(json)
                                        }
                                    }
                                    that.getusedcountbypoid(param);
                                     
                                }
                                if(that.searchtype == 3){
                                    let json = {
                                        id:val.toagent.agentid,
                                        poid : val.poid,
                                        type:val.totype,
                                        num:val.num,
                                        remark:val.remark,
                                        time:new Date(val.createtime*1000).format("yyyy/MM/dd HH:mm:ss"),
                                    }
                                    that.addmsg.push(json)
                                }
                            }
                            
                        }
                        if(res.totalpropsnum){
                            that.totalScreen = res.totalpropsnum
                        }else{
                            that.totalScreen = 0;
                        }
                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            propsorderdetaillist(page){
                var that = this;
                var req = {
                    searchtype:that.listtype,
                    poid:that.currentData.poid,
                    businesstype:that.currentData.type,
                    businessid:that.currentData.id,
                    page:{
                        pageno:page,
                        pagesize:10
                    }
                }
                that.screenData = [];
                that.httputil.post({
                    that: that,
                    url: that.api.propsorderdetaillist,
                    req: req,
                    xmsuccess: function (res) {
                        that.screenDataPage = res.page || {}
                        if(res.propsorderdetail){
                            for(let val of res.propsorderdetail){
                                let json = {
                                    id:val.id,
                                    mac:val.props.sncode,
                                    status:val.props.usestatus == 100?'未使用':'已使用',
                                    sort:val.props.status == 101?'已转出':'未转出',
                                    agent:val.toagent?val.toagent.name:'--',
                                    group:val.props.brand?val.props.brand.name:'--',
                                    store:val.props.store?val.props.store.name:'--',
                                    address:val.props.address?val.props.address:'--'
                                }
                                that.screenData.push(json)
                            }
                        }
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            getusedcountbypoid(param){
                let that = this;
                let req = {
                    poid:param.poid,
                    usestatus:101
                }
                that.httputil.post({
                    that: that,
                    url: that.api.getusedcountbypoid,
                    req: req,
                    xmsuccess: function (res) {
                        if(param) {
                            param.success(parseInt(res.num || "0"));
                        }
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            clearfile(){
                let that = this;
                that.upMore = false;
                that.fileList = [];
                that.macMoreRemark = '';
				$(".filebox .el-upload--text").show();
            },
            CanResetBinding(val){
               if (val.isOut != "已转出"){
                   return false;
               }
               if (val.MacAddress.indexOf("@") != -1){
                   return false;
               }
               return true;
            },
            showTip(val){
                let that = this;
                that.propid = parseInt(val.pid);
                that.sncodename = val.MacAddress;
                that.showretbind = true;
            },
             ResetBinding(){
                let that = this;
                let req = {
                    pidlist:[that.propid],
                    remark:"解绑屏幕",
                }
                that.httputil.post({
                    that: that,
                    url: that.api.resetbinding,
                    req: req,
                    xmsuccess: function (res) {
                        if (res.result.success){
                            that.superlist(1);
                             that.showretbind = false;
                            that.$message({
                                message:"解绑成功",
                                type: 'success'
                            })
                        }
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            superlist(page){
                let that = this;
                let req = {
                    sncode:that.searchMac,
                    typeid:1000,
                    page:{
                        pageno:page,
                        pagesize:10
                    }
                }
                that.allscode = [];
                that.httputil.post({
                    that: that,
                    url: that.api.superlist,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsinfo){
                            for(let val of res.propsinfo){
                                let isOut = val.status  == 101?'已转出':'——';
                                let name = '——';
                                if(val.ownertype == 400 && val.status  == 101){
                                    name = val.ownerstore.name + '【门店】'
                                }
                                if(val.ownertype == 300 && val.status  == 101){
                                    name = val.ownerbrand.name + '【集团】'
                                }
                                if(val.ownertype == 200 && val.status  == 101){
                                    name = val.owneragent.name + '【经销商】'
                                }
                                let json = {
                                    pid:val.pid,
                                    version:val.version?val.version.versionname:'——',
                                    online:val.online == 1?'在线':'离线',
                                    MacAddress:val.sncode,
                                    time:new Date(val.createtime*1000).format("yyyy/MM/dd HH:mm:ss"),
                                    isOut:isOut,
                                    name:name
                                }
                                that.allscode.push(json)
                            }
                        }
                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .list{
        width: 120px;
        height: 35px;
        display: inline-block;
        margin-right: 6px;
        line-height: 35px;
        color:#666;
        border:1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
        transition: all .3s;
    }
    .list.active{
        color: #fff;
        background: #18C3B1;
        border-color: #18C3B1;
    }
    .list:hover{
        color: #fff;
        background: #18C3B1;
        border-color: #18C3B1;
    }
    .searchbox{
        height: 40px;
    }
    .inputbox{
        width: 180px;
    }
    .searchbtn{
        border-radius: 10px;
        height: 35px;
        line-height: 35px;
        display: inline-block;
    }
    .searchbtns {
		display: inline-block;
		width: 90px;
		height: 35px;
		text-align: center;
		line-height: 35px;
		color: #fff;
		background: #18C3B1;
		margin-left: 14px;
		border-radius: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/screen.vue